// eslint-disable-next-line no-use-before-define
import React from 'react';
import { Link } from 'react-router-dom';
import './ROSideNav.scss';
import { styled } from '@mui/system';
import { Stack, Typography, useTheme } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';

const StyledLink = styled(Link)`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 14px 16px;
  text-decoration: none;
  border-bottom: solid 1px ${(props) => props.theme.palette.grey[300]};
  transition: border-color 0.15s ease-in-out;

  &:focus,
  &:hover,
  &:visited,
  &:link,
  &:active {
    text-decoration: none;
  }
`;

export const BackLink = ({ url, title }: { url: string; title: string }): JSX.Element => {
  const theme = useTheme();

  return (
    <StyledLink to={url}>
      <Stack direction="row" gap={2} alignItems="center">
        <ArrowBack color="primary" />
        <Stack>
          <Typography variant="body1">Back</Typography>
          <Typography variant="body2" color={theme.palette.text.secondary}>
            {title}
          </Typography>
        </Stack>
      </Stack>
    </StyledLink>
  );
};
